import React from 'react';
import './scss/Toggle.scss';

const Toggle = ({ 
  checked, 
  onChange, 
  label = "", 
  disabled = false,
  size = "md",
  loading = false 
}) => {
  const uniqueId = `toggle-${Math.random().toString(36).substr(2, 9)}`;

  const handleChange = () => {
    if (!disabled && !loading) {
      onChange(!checked);
    }
  };

  return (
    <div className={`toggle-container ${size}`}>
      {label && (
        <label htmlFor={uniqueId} className="toggle-label">
          {label}
        </label>
      )}
      <button
        type="button"
        id={uniqueId}
        role="switch"
        aria-checked={checked}
        disabled={disabled || loading}
        onClick={handleChange}
        className={`toggle-switch ${checked ? 'checked' : ''}`}
      >
        <span className="toggle-thumb">
          {loading && (
            <div className="toggle-spinner">
              <div className="spinner"></div>
            </div>
          )}
        </span>
      </button>
    </div>
  );
};

export default Toggle;
